define('tinymce-plugins/wa5_tableresize/plugin',['tinymce/AddOnManager'], function(AddOnManager) {
	var DRAG_START_THRESHOLD = 2;
	var MIN_CELL_WIDTH = 20; // pixel
	
	/**
	 * A plugin that allows resizing columns by dragging their borders 
	 */
	AddOnManager.PluginManager.add('wa5_tableresize', function(editor) {
		var currentTable = null;
		var currentColumnIndex = null;
		var $indicatorElement = null;
		var minIndicatorPos;
		var maxIndicatorPos;
		
		function cancelResize() {
			if ($indicatorElement) {
				$indicatorElement.remove();
				$indicatorElement = null;
			}
			currentColumnIndex = null;
			currentTable = null;
		}
		
		function initIndicator() {
			if ($indicatorElement)
				return;
			$indicatorElement = $('<div class="column-resize-indicator" contenteditable="false">').css({
				position: 'absolute',
				'z-index': 1000,
				'background-color': 'black',
				opacity: 0.5,
				'margin-left': '-1px', // center on border
				width: '2px'
			}).hide().appendTo($(editor.contentDocument).find('body'));
		}
		
		/**
		 * Initializes the resizing of a column
		 */
		function startResizeColumn(table, columnIndex) {
			cancelResize();
			
			if (columnIndex < 0 || columnIndex > getColumnCountOfTable(table))
				return; // don't resize left of first column or right of last column
			
			currentTable = table;
			currentColumnIndex = columnIndex;
			initIndicator();
			
			$indicatorElement.css({
				left: getColumnOffsetLeft(table, columnIndex + 1 /* place indicator to the right */),
				top: $(table).offset().top,
				height: $(table).height()
			})
			$indicatorElement.show();
			minIndicatorPos = getColumnOffsetLeft(table, columnIndex) + MIN_CELL_WIDTH;
			maxIndicatorPos = getColumnOffsetLeft(table, columnIndex + 2) - MIN_CELL_WIDTH;
		}
		
		function finishResize() {
			if (isResizing()) {
				editor.undoManager.transact(function() {
					var newWidth = $indicatorElement.offset().left - 
						getColumnOffsetLeft(currentTable, currentColumnIndex);
					resizeColumn(currentTable, currentColumnIndex, newWidth);
	
					// du during transaction so that $indicator is already deleted
					cancelResize();
				});
			} else
				cancelResize();
		}
		
		function isResizing() {
			return currentColumnIndex !== null;
		}
		
		function moveIndicator(x) {
			if (isResizing()) {
				x = Math.max(x, minIndicatorPos);
				x = Math.min(x, maxIndicatorPos);
				$indicatorElement.css('left', x);
			}
		}
		
		editor.on('mousedown', function(e) {
			if (e.which != 1) // only left button is relevant
				return;
			cancelResize();
			
			if (e.target && e.target.nodeName == 'TD') {
				var td = e.target;
				var table = $(td).closest('table')[0];
				var columnIndex = getColumnAt(table, td, e.pageX);
				
				if (columnIndex !== false) {
					startResizeColumn(table, columnIndex);
					//e.stopImmediatePropagation(); // don't select cells
				}
			}
		});

		editor.on('mouseup', function(e) {
			if (e.which == 1) // only left button is relevant
				finishResize();
		});
		
		editor.on('mousemove', function(e) {
			if (e.target && e.target.nodeName == 'TD') {
				var td = e.target;
				var table = $(td).closest('table')[0];
				var columnIndex = getColumnAt(table, td, e.pageX);
				
				if (isResizing() || columnIndex !== false)
					$(td).css('cursor', 'col-resize');
				else
					$(td).css('cursor', '');
				
				if (isResizing())
					moveIndicator(e.pageX);
			}
		});
		
		editor.on('mouseleave', function(e) {
			if (e.target && e.target.nodeName == 'TD')
				$(e.target).css('cursor', '');
		});
		
		editor.on('BeforeExecCommand', function(e) {
			// If a column is added, the column definition (which defines its width) must also be added
			switch (e.command) {
			case 'mceTableInsertColAfter':
			case 'mceTableInsertColBefore':
				var $firstTD = $(editor.selection.getNode()).closest('td');
				if (!$firstTD.length) {
					console.log('inserted column, but no cell selected');
					return;
				}
				var $table = $firstTD.closest('table');

				var $colgroup = $table.find('colgroup');
				// No column definitions yet (columns have not been resized yet), so nothing to do
				if (!$colgroup.length)
					return;
				
				var $colDefs = $colgroup.find('col');
				var firstTD = $firstTD[0];
				var columnIndex = getColumnIndexOfCell(firstTD);
				var $newColDef = $('<col>').css('width', 100 / $colDefs.length + '%'); // reasonable default
				var $referenceColDef = $($colDefs[columnIndex]);
				if (e.command == 'mceTableInsertColAfter')
					$newColDef.insertAfter($referenceColDef);
				else
					$newColDef.insertBefore($referenceColDef);
				
				// the total column definition width is now > 100%, so normalize it
				getCompleteColGroup($table);
				
				break;
			case 'mceTableDeleteCol':
				var selectedTD = $(editor.selection.getNode()).closest('td')[0];
				var $table = $(editor.selection.getNode()).closest('table');
				var $colgroup = $table.find('colgroup');

				// No column definitions yet (columns have not been resized yet), so nothing to do
				if (!$colgroup.length)
					return;
				
				var rows = getNormalizedCells($table);
				var firstColumnIndex = 10000;
				var lastColumnIndex = -1;
				rows.forEach(function(cells) {
					for (var columnIndex = 0; columnIndex < cells.length; columnIndex++) {
						var td = cells[columnIndex];
						if (td == selectedTD || $(td).hasClass('mce-item-selected')) {
							firstColumnIndex = Math.min(firstColumnIndex, columnIndex);
							lastColumnIndex = Math.max(lastColumnIndex, columnIndex);
						}
					}
				});
				
				if (lastColumnIndex >= 0) {
					var colDefs = $colgroup.children();
					for (var i = firstColumnIndex; i <= lastColumnIndex; i++) {
						colDefs[i].remove();
					}
				}
				
				// adjust coldef widths
				getCompleteColGroup();
					
				break;
			}
		});
		
		editor.on('ExecCommand', function(e) {
			switch (e.command) {
			case 'mceTableDeleteCol':
				var $table = $(editor.selection.getNode()).closest('table');
				var $colgroup = $table.find('colgroup');
				if ($colgroup.length)
					getCompleteColGroup($table); // normalize colgroup
				
				break;
			}
		});
		
		function getColumnAt(table, td, x) {
			var table = $(td).closest('table')[0];
			var tdLeft = $(td).offset().left; // absolute to iframe
			var xRelativeToLeft = x - tdLeft;
			var column = false;
			if (xRelativeToLeft >= 0 && xRelativeToLeft <= DRAG_START_THRESHOLD)
				// if column 1's left edge is dragged, column 0 is resized 
				column = getColumnIndexOfCell(td) - 1;
			else {
				var xRelativeToRight = x - (tdLeft + td.offsetWidth);
				if (xRelativeToRight <= 0 && xRelativeToRight >= -DRAG_START_THRESHOLD)
					column = getColumnIndexOfCell(td) + td.colSpan - 1;
			}
			
			// The outer columns don't count
			if (column < 0 || column >= getColumnCountOfTable(table) - 1)
				column = false;
			
			return column;
		}
		
		/**
		 * Gets a two-dimensional array that maps each (row,column) coordinate to a td element
		 */
		function getNormalizedCells(table) {
			var normalizedCells = [];
			var forwards = [];
			$(table).find('tr').each(function() {
				var row = $(this);
				var currentColumnIndex = 0;
				var normalizedRowCells = [];
				var currentForwards = forwards.length ? forwards.shift() : {};
				
				row.find('td').each(function() {
					var td = this;
					
					// See if there is a forward-declared cell here
					while (currentColumnIndex in currentForwards) {
						var forwardedCells = currentForwards[currentColumnIndex];
						normalizedRowCells = normalizedRowCells.concat(forwardedCells);
						currentColumnIndex += forwardedCells.length;
					}
					
					// Generate colSpan times td
					var normalizedCellCells = [];
					for (var i = 0; i < td.colSpan; i++)
						normalizedCellCells.push(td);
					
					normalizedRowCells = normalizedRowCells.concat(normalizedCellCells);
					
					// if this is a multi-row spanning cell, remember it for the next rows
					for (var forwardIndex = 0; forwardIndex < td.rowSpan - 1; forwardIndex++) {
						if (!forwards[forwardIndex])
							forwards[forwardIndex] = {};
						forwards[forwardIndex][currentColumnIndex] = normalizedCellCells;
					}
					
					currentColumnIndex += td.colSpan;
				});

				
				// See if there is a forward-declared cell after the last column
				while (currentColumnIndex in currentForwards) {
					var forwardedCells = currentForwards[currentColumnIndex];
					normalizedRowCells = normalizedRowCells.concat(forwardedCells);
					currentColumnIndex += forwardedCells.length;
				}
				
				normalizedCells.push(normalizedRowCells);
			});
			
			return normalizedCells;
		}
		
		function getColumnCountOfTable(table) {
			var cells = getNormalizedCells(table);
			if (!cells.length)
				return 0;
			return cells[0].length;
		}
		
		function getColumnIndexOfCell(td) {
			var table = $(td).closest('table')[0];
			var rows = getNormalizedCells(table);
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				for (var j = 0; j < row.length; j++) {
					if (row[j] == td)
						return j;
				}
			}
			throw new Error('td not found');
		}
		
		function getColumnOffsetLeft(table, columnIndex) {
			var cols = getCompleteColGroup(table).children();
			var offset = 0;
			for (var i = 0; i < columnIndex; i++) {
				offset += getColDefWidth(cols[i]);
			}
			return $(table).offset().left + offset * $(table).width();
		}
		
		function resizeColumn(table, columnIndex, newWidth) {
			newWidth /= $(currentTable).width();

			var colgroup = getCompleteColGroup(table);
			var cols = colgroup.find('col');
			var col = $(cols[columnIndex]);
			var oldWidth = getColDefWidth(col[0]);
			setCSS(col, { width: newWidth * 100 + '%' });

			var nextCol = $(cols[columnIndex + 1]);
			var newNextWidth = getColDefWidth(nextCol[0]) - (newWidth - oldWidth);
			setCSS(nextCol, { width: newNextWidth * 100 + '%' });
		}
		
		function getCompleteColGroup(table) {
			var colgroup = $(table).find('colgroup');
			if (!colgroup.length)
				colgroup = $('<colgroup>').prependTo($(table));
			
			var columnCount = getColumnCountOfTable(table);
			var colDefCount = colgroup.find('col').length;
			// make sure that there are exact columnCount <col> elements
			if (colDefCount < columnCount) {
				for (var i = 0; i < columnCount - colDefCount; i++) {
					$('<col>').css('width', (100 / columnCount) + '%').appendTo(colgroup);
				}
			}
			if (colDefCount < columnCount) {
				for (var i = 0; i < colDefCount - columnCount; i++)
					colgroup.find('col').last().remove();
			}
			
			// make sure that the sum of the widths is 100%
			var currentTotalWidth = 0;
			var colDefs = colgroup.find('col');
			for (var i = 0; i < colDefs.length; i++) {
				currentTotalWidth += getColDefWidth(colDefs[i]);
			}
			
			if (currentTotalWidth != 1) {
				var factor = 1 / currentTotalWidth;
				for (var i = 0; i < colDefs.length; i++) {
					var col = colDefs[i];
					if (currentTotalWidth == 0) { // no widths, make all equal
						setCSS(col, { width: (100 / currentTotalWidth) + '%' });
					} else {
						setCSS(col, { width: getColDefWidth(col) * factor * 100 + '%' });
					}
				}
			}
			
			return colgroup;
		}
		
		/**
		 * Gets the relative column width
		 */
		function getColDefWidth(col) {
			var table = $(col).closest('table')[0];
			col = $(col);
			var css = col.attr('style') || '';
			var widthRule = css.match(/width:\s*([0-9\.]+)\s*%\s*(;|$)/);
			var width = widthRule && parseFloat(widthRule[1]) / 100;
			if (!isNaN(width))
				return width;
			else {
				// make it %y
				var width = col.width() / $(table).width();
				setCSS(col, { width: width * 100 + '%' });
				return width;
			}
		}

		function setCSS(elem, properties) {
			if (!('length' in elem)) {
				elem = $(elem);
			}
			elem.css(properties).attr('data-mce-style', elem.attr('style'));
		}
	});
});

